import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, SxProps } from '@mui/material'
import { CustomDialogContent, DestructiveActionIcon, DialogHeader } from './ClientConfigToolStyles'
import React, { FormEvent } from 'react'
import CloseOutlined from '@mui/icons-material/CloseOutlined'
import ErrorOutline from '@mui/icons-material/ErrorOutline'

interface DisableWotcConfirmDialogProps {
  open: boolean
  handleClose: () => void
  handleSubmit: (event: FormEvent) => void
}

const sx: SxProps = {
  '& .MuiDialog-container': {
    alignItems: 'flex-start'
  }
}

function DisableWotcConfirmDialog({open, handleClose, handleSubmit}: DisableWotcConfirmDialogProps) {
  return (
    <Dialog
      PaperProps={{sx: {marginTop: '3.5rem', width: '37.5rem'}}}
      open={open}
      sx={sx}
    >
      <DialogTitle>
        <Grid
          columns={17}
          container
          direction="row"
          spacing={0}
        >
          <Grid item xs={2}>
            <DestructiveActionIcon>
              <ErrorOutline sx={{ color: '#DC2626', fontSize: 22 }} />
            </DestructiveActionIcon>
          </Grid>
          <Grid item xs={14}/>
          <Grid item xs={1}>
            <CloseOutlined onClick={handleClose} sx={{color: 'rgba(0, 0, 0, 0.87)'}} />
          </Grid>
        </Grid>
        <DialogHeader>Disable WOTC configuration</DialogHeader>
      </DialogTitle>
      <DialogContent>
        <CustomDialogContent>You are about to disable wotc configuration for this client. Do you want to continue ? </CustomDialogContent>
      </DialogContent>
      <DialogActions sx={{padding: '0.5rem 1.5rem'}}>
        <Button onClick={handleClose}>Cancel</Button>
        <Button 
          color="error" 
          onClick={handleSubmit}
          sx={{ background: '#DC2626' }} 
          variant="contained"
        >
            Continue
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DisableWotcConfirmDialog